import React from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { classNames } from '@/helpers/classNames';

import dashboardStyles from '../../Dashboard.module.scss';
import styles from './FaqPanel.module.scss';

export interface FAQPanelProps {
	toggleMessenger: () => void;
}

export const FAQPanel = React.memo(({ toggleMessenger }: FAQPanelProps) => (
	<div className={styles['root']}>
		<div className={dashboardStyles['title']}>
			Need help?
		</div>
		<div className={styles['content']}>
			<AsaphButton
				label="Help Center"
				color="grey"
				fullWidth
				to="https://help.asaph.io/en/"
				target="_blank"
				className={styles['button']}
			/>
			<AsaphButton
				id="intercom"
				label="Ask a question"
				color="grey"
				fullWidth
				onClick={toggleMessenger}
				className={styles['button']}
			/>
		</div>
	</div>
));

export default FAQPanel;
